"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plus = void 0;
const react_1 = __importDefault(require("react"));
exports.Plus = (props) => {
    return (react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", viewBox: "0 0 7 9" }, props),
        react_1.default.createElement("path", { fill: "#fff", d: "M4.108 3.661h2.776v1.196H4.108v3.145H2.837V4.857H.062V3.661h2.775V.756h1.271V3.66z" })));
};
